import { type IDetailIndexPorps } from '@interface/IDetail';
import ItemIndex from './ItemIndex';
import { SecAttribute } from './SecAttribute';
import { SecDecompSrc } from './SecDecompSrc';
import { SecSet } from './SecSet';
import { SecSummary } from './SecSummary';

export const ItemIndexBns = ({ props }: { props: IDetailIndexPorps }) => {
    return (
        <ItemIndex props={props}>
            <div className="gameinfo-detail__left">
                <SecSummary props={props} />
                <SecAttribute props={props} />
            </div>
            <div className="gameinfo-detail__right">
                <SecSet props={props} />
                <SecDecompSrc props={props} />
            </div>
        </ItemIndex>
    );
};
export default ItemIndexBns;
